export default __webpack_public_path__ + "GothaProMed.otf";